export default __webpack_public_path__ + "static/open_house_may_2019_2-462d377e1e65711fdfb915ed801c5349.jpg";